import i18n from '@/i18n'

import { humanDate } from './humanDate.js'

export const endDatePassedOrNull = (endDate) => {
  return endDate === null || new Date() > new Date(endDate)
}

export const details = (activity) => {
  const date = endDatePassedOrNull(activity.end_date)
    ? i18n.global.t('timeless')
    : humanDate(activity.start_date)

  return `${date} - ${activity.groups[activity.group_id].location.type}`
}
